// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__yG1DD","content":"NotFound_content__1npHO"};